import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: "Trading Platform", path: "/trading-interface" },
      { label: "Account Dashboard", path: "/account-dashboard" },
      { label: "Funding Portal", path: "/funding-portal" },
      { label: "Security Center", path: "/security-center" }
    ],
    company: [
      { label: "About Us", path: "/homepage" },
      { label: "Careers", path: "/homepage" },
      { label: "Press", path: "/homepage" },
      { label: "Blog", path: "/homepage" }
    ],
    resources: [
      { label: "Learning Center", path: "/homepage" },
      { label: "Market Analysis", path: "/homepage" },
      { label: "API Documentation", path: "/homepage" },
      { label: "Help Center", path: "/homepage" }
    ],
    legal: [
      { label: "Privacy Policy", path: "/homepage" },
      { label: "Terms of Service", path: "/homepage" },
      { label: "Compliance", path: "/homepage" },
      { label: "Cookie Policy", path: "/homepage" }
    ]
  };

  const socialLinks = [
    { icon: "Twitter", label: "Twitter", url: "#" },
    { icon: "Facebook", label: "Facebook", url: "#" },
    { icon: "Linkedin", label: "LinkedIn", url: "#" },
    { icon: "Instagram", label: "Instagram", url: "#" },
    { icon: "Youtube", label: "YouTube", url: "#" }
  ];

  return (
    <footer className="bg-[var(--color-card)] border-t border-[var(--color-border)]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 md:gap-12 mb-8 md:mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-secondary)]">
                <Icon name="Lock" size={24} color="#FFFFFF" />
              </div>
              <span className="text-xl font-semibold text-[var(--color-foreground)]">Kryptostash</span>
            </div>
            <p className="text-sm md:text-base text-[var(--color-muted-foreground)] mb-6 max-w-sm">
              Your secure gateway to cryptocurrency investing. Bank-level security meets user-friendly design for confident digital asset management.
            </p>
            <div className="flex items-center gap-4">
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.url}
                  className="w-10 h-10 rounded-full bg-[var(--color-muted)] flex items-center justify-center hover:bg-[var(--color-primary)] transition-colors duration-300 group"
                  aria-label={social?.label}
                >
                  <Icon 
                    name={social?.icon} 
                    size={20} 
                    className="text-[var(--color-muted-foreground)] group-hover:text-white transition-colors duration-300"
                  />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-[var(--color-foreground)] mb-4">Product</h3>
            <ul className="space-y-3">
              {footerLinks?.product?.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link?.path}
                    className="text-sm md:text-base text-[var(--color-muted-foreground)] hover:text-[var(--color-primary)] transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-[var(--color-foreground)] mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link?.path}
                    className="text-sm md:text-base text-[var(--color-muted-foreground)] hover:text-[var(--color-primary)] transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-[var(--color-foreground)] mb-4">Resources</h3>
            <ul className="space-y-3">
              {footerLinks?.resources?.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link?.path}
                    className="text-sm md:text-base text-[var(--color-muted-foreground)] hover:text-[var(--color-primary)] transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-[var(--color-foreground)] mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link?.path}
                    className="text-sm md:text-base text-[var(--color-muted-foreground)] hover:text-[var(--color-primary)] transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[var(--color-border)]">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-[var(--color-muted-foreground)] text-center md:text-left">
              © {currentYear} Kryptostash. All rights reserved. FinCEN MSB Registered.
            </p>
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={16} color="var(--color-success)" />
                <span className="text-sm text-[var(--color-muted-foreground)]">FDIC Insured</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Lock" size={16} color="var(--color-success)" />
                <span className="text-sm text-[var(--color-muted-foreground)]">256-bit SSL</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;